import { Funds } from '~/features/bank/components/Funds'
import { Category } from './Category'
import { Collection } from './Collection'
import { Filters } from './filters'
import { OrderHistory } from './OrderHistory'

/**
 * What you can spend, stated before you start browsing. The store settles against `usdc` only, so
 * a shopper carrying bonus funds needs to know they are not part of the budget here — finding that
 * out at checkout is finding it out too late.
 */
const StoreBalanceBar = () => (
    <div className='flex flex-col md:flex-row md:items-center md:justify-between gap-2 md:gap-4 px-4 py-3 mx-4 border border-white/10 bg-white/[0.03]'>
        <Funds.Summary className='text-base' />
        <Funds.Note className='md:justify-end md:text-right' />
    </div>
)

export const Store = () => {
    return (
        <div className='flex flex-col'>
            <OrderHistory />
            <div className='tracking-wide'>
                <Category.List />
                <StoreBalanceBar />
                <div className='flex flex-row'>
                    <Filters.Panel />
                    {/* `min-w-0` is load-bearing. This column is a flex item, so its automatic
                        minimum is its content's min-content width — and a list row contains a
                        `truncate`d name, which is `white-space: nowrap` and therefore reports the
                        *whole* name as its minimum. Without this the column refused to shrink
                        below ~407px and a 375px phone scrolled sideways. The grid view had been
                        hiding it: its cards are capped at 320px by `place-content-center`. */}
                    <div className='grow min-w-0 flex flex-col'>
                        <Collection.Grid />
                    </div>
                </div>
            </div>
        </div>
    )
}
